import ContentLoader from 'react-content-loader';

export default function LineShimmer() {
  return (
    <ContentLoader viewBox="0 0 150 8">
      <rect x="0" y="2" rx="3" ry="3" width="80" height="3" />
    </ContentLoader>
  );
}
